// @see https://quirksmode.org/html5/inputs/tests/inputs_js.html
function browserSupportsDateInput() {
  if (!document) {
    return false
  }
  const input = document.createElement('input')
  const desiredType = 'date'
  // document.querySelector('body').appendChild(input)
  input.setAttribute('type', 'date')
  input.value = 'Hello world'
  // console.log(
  //   'input.type === desiredType',
  //   input.type === desiredType,
  //   input.type,
  //   desiredType,
  // )
  // console.log(
  //   "input.value !== 'Hello world'",
  //   input.value !== 'Hello world',
  //   input.value,
  //   'Hello world',
  // )
  return input.type === desiredType && input.value !== 'Hello world'
}

export { browserSupportsDateInput }
